import { Dispatch, FC, SetStateAction, useCallback } from "react";

import PagePanel from "components/ui/Panel/PagePanel";
import ImportYML from "components/ImportMaster/ImportYML";
import ImportExcel from "components/ImportMaster/ImportExcel";
import ImportManual from "components/ImportMaster/ImportManual";
import { useParams } from "react-router";

export type ImportModeType = "yml" | "xls" | "manual";

interface IImportModePanelProps {
  isPeriodicTaskEditMode: boolean;
  uploadMode: "file" | "url";
  setUploadMode: Dispatch<SetStateAction<"file" | "url">>;
}

const ImportModePanel: FC<IImportModePanelProps> = ({
  isPeriodicTaskEditMode,
  uploadMode,
  setUploadMode
}) => {
  const { mode } = useParams<{ mode: ImportModeType }>();

  const ImportModeBlock = useCallback((): JSX.Element => {
    switch (mode) {
      case "yml":
        return (<ImportYML
          isPeriodicTaskEditMode={isPeriodicTaskEditMode}
          uploadMode={uploadMode}
          setUploadMode={setUploadMode}
        />);

      case "xls":
        return <ImportExcel />;

      case "manual":
        return <ImportManual />;

      default:
        return <ImportManual />;
    }
  }, [mode, isPeriodicTaskEditMode, uploadMode]);

  return (
    <PagePanel className="flex flex-row gap-4">
      <ImportModeBlock />
    </PagePanel>
  );
};

export default ImportModePanel;
